import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { PATH } from 'app/constants/path';

const HamburgerButton = styled.button<{ top?: number; right?: number }>`
  display: flex;
  opacity: 1;
  position: fixed;
  top: ${({ top }) => top || 88}px;
  right: ${({ right }) => right || 20}px;
  z-index: ${(props) => props.theme['drawer-z-index'] + 1 || 1051};
  background: var(--primary, #0066cc);
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 5px;
  transition: all 0.3s ease;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  width: 28px;
  height: 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3px;

  &:hover {
    background-color: var(--primary-dark, #0055aa);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }

  @media (min-width: 992px) {
    opacity: 0;
  }
`;

const HamburgerLine = styled.span<{ $isOpen?: boolean }>`
  display: block;
  width: 14px;
  height: 1.5px;
  background-color: white;
  border-radius: 1px;
  transition: all 0.3s ease;

  &:nth-child(1) {
    transform: ${(props) => (props.$isOpen ? 'rotate(45deg) translate(3px, 3px)' : 'rotate(0)')};
    transform-origin: center;
  }

  &:nth-child(2) {
    opacity: ${(props) => (props.$isOpen ? '0' : '1')};
    width: ${(props) => (props.$isOpen ? '14px' : '11px')};
  }

  &:nth-child(3) {
    transform: ${(props) => (props.$isOpen ? 'rotate(-45deg) translate(3px, -3px)' : 'rotate(0)')};
    transform-origin: center;
  }
`;

interface HamburgerMenuProps {
  isOpen: boolean;
  toggleMenu: () => void;
}

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({ isOpen, toggleMenu }) => {
  const location = useLocation();
  const isDashboardPage = location.pathname.includes(PATH.DASHBOARD);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!isMobile) {
    return null;
  }

  return (
    <HamburgerButton
      top={!isDashboardPage ? 10 : 88}
      right={!isDashboardPage ? 6 : 20}
      onClick={toggleMenu}
      aria-label="Toggle menu"
    >
      <HamburgerLine $isOpen={isOpen} />
      <HamburgerLine $isOpen={isOpen} />
      <HamburgerLine $isOpen={isOpen} />
    </HamburgerButton>
  );
};

export default HamburgerMenu;
